import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { getRequest } from '../../services/api/apiService';

// Bannière d'avertissement globale : une plateforme est CONNECTÉE (OAuth ok)
// mais AUCUN compte publicitaire n'est sélectionné — campagnes et stats ne
// remontent pas tant que le compte n'est pas choisi (cause réelle des erreurs
// "no advertiser ID selected" après une reconnexion). Affichée en haut du
// contenu sur toutes les pages sauf Plateformes (où l'on corrige justement).
const PLATFORM_LABELS = { meta: 'Meta', tiktok: 'TikTok', google: 'Google', snapchat: 'Snapchat', linkedin: 'LinkedIn' };

const AccountsWarningBanner = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [missing, setMissing] = useState([]);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    getRequest('/api/connected-platforms/accounts-status')
      .then((res) => setMissing((res.platforms || []).filter((p) => p.missingAccount).map((p) => p.platform)))
      .catch(() => {});
    // Re-vérifie à chaque changement de page : la sélection a pu être faite.
  }, [location.pathname]);

  if (dismissed || missing.length === 0) return null;
  if (location.pathname.includes('connected-platforms')) return null;

  const labels = missing.map((p) => PLATFORM_LABELS[p] || p).join(', ');
  return (
    <div className="mb-4 rounded-xl bg-amber-50 border border-amber-300 px-4 py-3 flex items-center gap-3 flex-wrap">
      <span className="text-lg">⚠️</span>
      <p className="text-xs md:text-sm text-amber-800 flex-1 min-w-[200px]">
        <b>{labels}</b> : plateforme connectée mais <b>aucun compte publicitaire sélectionné</b> —
        les campagnes et statistiques ne remontent pas tant que le compte n'est pas choisi.
      </p>
      <div className="flex items-center gap-2">
        <button
          onClick={() => navigate('/dashboard/connected-platforms')}
          className="text-xs font-semibold text-white bg-amber-500 hover:bg-amber-600 rounded-lg px-3.5 py-2 transition"
        >
          Choisir le compte →
        </button>
        <button
          onClick={() => setDismissed(true)}
          title="Masquer jusqu'au prochain chargement"
          className="text-amber-400 hover:text-amber-600 text-sm px-1"
        >
          ✕
        </button>
      </div>
    </div>
  );
};

export default AccountsWarningBanner;
